import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LinkedinIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.5298 2H3.49792C2.69348 2 2 2.638 2 3.44244V20.5298C2 21.3343 2.44383 21.9723 3.27601 21.9723H20.3079C21.1123 21.9723 22 21.3343 22 20.5298V3.44244C22 2.638 21.362 2 20.5576 2H20.5298ZM7.71429 19.1151H4.85714V9.60055H7.71429V19.1151ZM6.27184 8.0749C5.27323 8.0749 4.49653 7.27046 4.49653 6.29958C4.49653 5.32871 5.30097 4.52427 6.27184 4.52427C7.24272 4.52427 8.04716 5.32871 8.04716 6.29958C8.04716 7.27046 7.24272 8.0749 6.27184 8.0749ZM19.1151 19.1151H16.258V14.344C16.258 13.068 15.7587 11.9584 14.5659 11.9584C13.3731 11.9584 12.4577 12.9293 12.4577 14.5104V19.0874H9.60055V9.60055H12.2913V10.9598H12.319C12.7351 10.2108 13.9279 9.46186 15.4258 9.46186C18.3107 9.46186 19.0874 10.9875 19.0874 13.8169V19.0874L19.1151 19.1151Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LinkedinIcon.displayName = 'LinkedinIcon';
